(ns frontend.view.grid.fundraising-opportunities-grid.columns)


(def not-available
  #{:common/attachments
    :fundraising-opportunity/ratings
    ;;TODO if we want to use these, we should add these as attributes to each fundraising-opportunity-entity:
    :role/guest-buy-side})

;;default set of selected columns
(def ordered-default-columns
  [:fundraising-opportunity/opportunity-name
   :fundraising-opportunity/cur-commitment-amount
   :fundraising-opportunity/opportunity-stage
   :fundraising-opportunity/owner
   :fundraising-opportunity/status
   :fundraising-opportunity/overview])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:fundraising-opportunity/opportunity-name})

(def my-fundraising-opportunities-ordered-columns
  [:fundraising-opportunity/opportunity-name
   :fundraising-opportunity/cur-commitment-amount
   :fundraising-opportunity/opportunity-stage
   :fundraising-opportunity/owner
   :fundraising-opportunity/status
   :fundraising-opportunity/overview])

(def my-fundraising-opportunities-columns
  (set my-fundraising-opportunities-ordered-columns))

(def lost-fundraising-opportunities-ordered-columns
  [:fundraising-opportunity/opportunity-name
   :fundraising-opportunity/cur-commitment-amount
   :fundraising-opportunity/opportunity-stage
   :fundraising-opportunity/owner
   :fundraising-opportunity/overview])

(def lost-fundraising-opportunities-columns
  (set lost-fundraising-opportunities-ordered-columns))

(def fundraising-opportunities-on-hold-ordered-columns
  [:fundraising-opportunity/opportunity-name
   :fundraising-opportunity/cur-commitment-amount
   :fundraising-opportunity/opportunity-stage
   :fundraising-opportunity/owner
   :fundraising-opportunity/overview])

(def fundraising-opportunities-on-hold-columns
  (set fundraising-opportunities-on-hold-ordered-columns))

(def new-fundraising-opportunities-this-q-ordered-columns
  [:fundraising-opportunity/opportunity-name
   :fundraising-opportunity/cur-commitment-amount
   :fundraising-opportunity/opportunity-stage
   :fundraising-opportunity/owner
   :fundraising-opportunity/status
   :fundraising-opportunity/overview])

(def new-fundraising-opportunities-this-q-columns
  (set new-fundraising-opportunities-this-q-ordered-columns))

(def fundraising-opportunity-progress-columns
  #{:fundraising-opportunity/opportunity-name
    :fundraising-opportunity/investor
    :fundraising-opportunity/cur-commitment-amount
    :fundraising-opportunity/description
    :fundraising-opportunity/overview
    :fundraising-opportunity/opportunity-stage})

(def fundraising-opportunity-details-columns
  #{:fundraising-opportunity/opportunity-name
    :fundraising-opportunity/owner
    :fundraising-opportunity/opportunity-stage
    :fundraising-opportunity/description
    :fundraising-opportunity/cur-commitment-amount})
